import ModalService from './ModalService'

export const modalService = new ModalService()
